import { render, staticRenderFns } from "./manage-apps.vue?vue&type=template&id=bdd1e026&scoped=true&"
import script from "./manage-apps.vue?vue&type=script&lang=js&"
export * from "./manage-apps.vue?vue&type=script&lang=js&"
import style0 from "./manage-apps.vue?vue&type=style&index=0&id=bdd1e026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1e026",
  null
  
)

export default component.exports